import React                   from 'react';
import PizzaItem
								from './PizzaItem';
import Button
								from 'reactstrap/es/Button';
import Card
								from 'reactstrap/es/Card';
import CardHeader
								from 'reactstrap/es/CardHeader';
import CardBody
								from 'reactstrap/es/CardBody';
import Row
								from 'reactstrap/es/Row';
import Col
								from 'reactstrap/es/Col';
import PizzaName
								from './PizzaName';
import { NotificationService }  from '../../services';
import NotificationAlert
								from 'react-notification-alert/index';
import { pizzaDeliveryService } from '../../services/pizza.delivery.service';

class PizzaDetails extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			config: this.props.config,
		}
	}

	static getDerivedStateFromProps(nextProps, prevState) {
		if (prevState.config !== nextProps.config) {
			return { config: nextProps.config };
		}

		return null;
	}


	addNewStep = () => {
		var {config} = this.state;
		if (config.Steps) {
			config.Steps.push({
				ID: null,
				Order: null,
				OrderTrackerConfigID: config.ID,
				HeaderText: 'CHANGE ME',
				DescriptionText: 'CHANGE ME',
				PipelineID: 72,
				StageID: 0
			});
		} else {
			config.Steps = [{
				ID: null,
				Order: null,
				OrderTrackerConfigID: config.ID,
				HeaderText: 'CHANGE ME',
				DescriptionText: 'CHANGE ME',
				PipelineID: 72,
				StageID: 0
			}];
		}

		this.setState({config: config});
	}

	onConfigChange = (change, index) => {
		var {config} = this.state;
		config.Steps[index] = change;
		this.setState({config: config});
	}

	onDetailsChanged = (details) => {
		this.setState({config: details});
	}

	onConfigStepDeleted = (index) => {
		var {config} = this.state;
		config.Steps.splice(index, 1);
		this.setState({config: config});
	}

	onSaveConfig = () => {
		//validate and provide an error for each error
		let {config} = this.state;
		var hasError = false;
		if (config.Name.length === 0) {
			this.refs.notificationAlert.notificationAlert(NotificationService.notify('tc', 4, "A valid name is required"));
			hasError = true;
		}
		if (!config.Steps || config.Steps.length === 0) {
			this.refs.notificationAlert.notificationAlert(NotificationService.notify('tc', 4, "At least 1 step is required"));
			return;
		}
		for (var i = 0; i < config.Steps.length; i++) {
			if (config.Steps[i].HeaderText.length === 0) {
				this.refs.notificationAlert.notificationAlert(NotificationService.notify('tc', 4, `Step ${i + 1} needs a Header Text`));
				hasError = true;
			}
			if (config.Steps[i].DescriptionText.length === 0) {
				this.refs.notificationAlert.notificationAlert(NotificationService.notify('tc', 4, `Step ${i + 1} needs a Description Text`));
				hasError = true;
			}
			if (!config.Steps[i].PipelineID) {
				this.refs.notificationAlert.notificationAlert(NotificationService.notify('tc', 4, `Step ${i + 1} needs a Pipeline`));
				hasError = true;
			}
			if (!config.Steps[i].StageID) {
				this.refs.notificationAlert.notificationAlert(NotificationService.notify('tc', 4, `Step ${i + 1} needs a Stage`));
				hasError = true;
			}
			config.Steps[i].Order = i + 1;
		}
		if (!hasError) {
			pizzaDeliveryService.saveConfig(config).then((response) => {
				this.refs.notificationAlert.notificationAlert(NotificationService.notify('tc', 2, `Configuration (${config.Name}) saved`));
				if (this.props.onSaveCallback) {
					this.props.onSaveCallback();
				}
				this.setState({config: response.Data})
			})
			.catch(err => {
				this.refs.notificationAlert.notificationAlert(NotificationService.notify('tc', 3, "Error: " + err));
			});
		}
	}

	onDeleteConfig = () => {
		const {config} = this.state;
		pizzaDeliveryService.deleteConfig(config).then((response) => {
			this.refs.notificationAlert.notificationAlert(NotificationService.notify('tc', 2, `Configuration (${config.Name}) removed`));
			if (this.props.onSaveCallback) {
				this.props.onSaveCallback();
			}
		})
		.catch(err => {
			this.refs.notificationAlert.notificationAlert(NotificationService.notify('tc', 3, "Error: " + err));
		});
	}

	onSalesAreaHandler = (salesArea) => {
		let {config} = this.state;
		config.SalesAreaID = salesArea ? salesArea.ID : 0;
		this.setState({config: config});
	}

	render() {
		const {config} = this.state;
		const {pipedrive} = this.props;
		return (
			<>
				<NotificationAlert ref="notificationAlert" />
				{config && <Row>
					<Col xs={12}>
						<Card>
							<CardHeader>
								<h4>"{config.Name}" Details</h4>
							</CardHeader>
							<CardBody>
								<PizzaName onSaveHandler={this.onSaveConfig} onDeleteHandler={this.onDeleteConfig} onConfigChange={this.onDetailsChanged} onSalesAreaHandler={this.onSalesAreaHandler} config={config}/>
							</CardBody>
						</Card>
					</Col>
				</Row> }

				<Row>
					<Col xs={12}>
						<Card>
							<CardHeader>
								<h4>Steps</h4>
							</CardHeader>
							<CardBody>
								{
									config && config.Steps && config.Steps.map(s => {
										return (
											<PizzaItem onDeleted={this.onConfigStepDeleted} onConfigChange={this.onConfigChange} pipedrive={pipedrive} configIndex={config.Steps.indexOf(s)} key={config.Steps.indexOf(s)} config={s}/>
										)
									})
								}
								<Button onClick={this.addNewStep}>Add New Step</Button>
							</CardBody>
						</Card>
					</Col>
				</Row>

			</>
		)
	}
}

export default PizzaDetails;
